export default __webpack_public_path__ + "static/media/filter-icon.3b8a18cf.svg";